import { Box, IconButton } from "@wix/design-system";
import { ArrowLeft, X } from "@wix/wix-ui-icons-common";
import React from "react";

export const MobileBottomSheetHeader = ({
  content,
  onClose,
  onBackClick,
}: {
  content: React.ReactNode;
  onClose?: () => void;
  onBackClick?: () => void;
}) => {
  return (
    <Box
      padding="0 12px 12px 16px"
      align="space-between"
      verticalAlign="middle"
    >
      <Box gap="4px" verticalAlign="middle">
        {onBackClick ? (
          <Box verticalAlign="middle" align="space-between" width="100%">
            <IconButton
              size="medium"
              skin="dark"
              priority="tertiary"
              onClick={onBackClick}
            >
              <ArrowLeft color="var(--wds-color-text-standard-primary)" />
            </IconButton>
            {content}
          </Box>
        ) : (
          <Box>{content}</Box>
        )}
      </Box>
      <IconButton skin="dark" priority="tertiary" onClick={onClose}>
        <X onClick={onClose} />
      </IconButton>
    </Box>
  );
};
